exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section.merchant-site-survey .form-input-wrapper{padding:10px 0;margin-bottom:10px}.section.merchant-site-survey .form-input-wrapper .rep-info{padding-top:10px}.section.merchant-site-survey .form-input-wrapper .rep-info label{font-weight:500}", ""]);

// exports
